import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8067f240"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = { class: "" };
const _hoisted_4 = { class: "field" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "sourceServiceText" }, "交換元サービス", -1));
const _hoisted_6 = { class: "field" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "targetServiceText" }, "交換先サービス", -1));
const _hoisted_8 = { class: "field" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "exchangeRate" }, "交換倍率", -1));
const _hoisted_10 = { class: "input-with-prefix" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "prefix" }, "×", -1));
const _hoisted_12 = { class: "field" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "effective_period_date" }, "有効日数", -1));
const _hoisted_14 = { style: { "display": "flex" } };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { style: { "font-size": "20px" } }, "日", -1));
const _hoisted_16 = { class: "button-row" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "btn-setting",
    type: "submit"
}, "削除", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TwoLineTitle = _resolveComponent("TwoLineTitle");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_TwoLineTitle, {
                    msgLine1: 'ポイント交換',
                    msgLine2: '倍率削除',
                    submsgLine1: 'Points Conversion',
                    submsgLine2: 'Rate Delete'
                })
            ]),
            _createElementVNode("div", null, [
                _createElementVNode("form", {
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
                    //@ts-ignore
                    (...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _withDirectives(_createElementVNode("input", {
                            id: "sourceServiceText",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.form.sourceService) = $event)),
                            disabled: ""
                        }, null, 512), [
                            [_vModelText, $data.form.sourceService]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("input", {
                            id: "targetServiceText",
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.form.targetService) = $event)),
                            disabled: ""
                        }, null, 512), [
                            [_vModelText, $data.form.targetService]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _withDirectives(_createElementVNode("input", {
                                id: "exchangeRate",
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.form.exchangeMagnification) = $event)),
                                disabled: ""
                            }, null, 512), [
                                [_vModelText, $data.form.exchangeMagnification]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "effective_period_date",
                                name: "effective_period_date",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.form.effectivePeriodDate) = $event)),
                                disabled: ""
                            }, null, 512), [
                                [_vModelText, $data.form.effectivePeriodDate]
                            ]),
                            _hoisted_15
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                            class: "btn-back",
                            type: "button",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => ($options.onCancel && $options.onCancel(...args)))
                        }, " 戻る "),
                        _hoisted_17
                    ])
                ], 32)
            ])
        ])
    ]));
}
